import { Keys, locale } from 'src/i18n';

export const PATH_I18N_CONFIG_CURRENCY = ['i18n_config', 'currency'] as const;
export const PATH_METRIC_DATA_TYPE = [
  'data',
  'body',
  'result',
  'metric',
  'data_type',
] as const;
export const PATH_METRIC_TARGET_VALUE = [
  'data',
  'body',
  'result',
  'metric',
  'target',
  'value',
] as const;
export const PATH_METRIC_VALUE = [
  'data',
  'body',
  'result',
  'metric',
  'value',
] as const;
export const PATH_METRIC_TARGET_PROGRESS_PERCENTAGE = [
  'data',
  'body',
  'result',
  'metric',
  'target',
  'progress_percentage',
] as const;
export const PATH_METRIC_TARGET_PROGRESS_TYPE = [
  'data',
  'body',
  'result',
  'metric',
  'target',
  'progress_type',
] as const;
export const PATH_PROGRESS_TYPE_SETTINGS = [
  'data',
  'body',
  'progress_type_settings',
] as const;
export const PATH_ROW_METRIC_TARGET_ATTRIBUTES = [
  'data',
  'body',
  'result',
  'metric',
  'target',
  'attributes',
] as const;
export const PATH_TEAM_ROW_METRIC_TARGET_ATTRIBUTES = [
  'body',
  'result',
  'metric',
  'target',
  'attributes',
] as const;
export const PATH_DETAILS_METRIC_TARGET_ATTRIBUTES = [
  'result',
  'metric',
  'target',
  'attributes',
] as const;
export const PATH_DETAILS_METRIC_TARGET_EXPECTED_PROGRESS = [
  'result',
  'metric',
  'target',
  'expected_progress',
] as const;
export const PATH_DETAILS_ACHIEVED_BY_VALUE = ['achievedBy', 'value'] as const;
export const PATH_DETAILS_METRIC_TARGET_VALUE = [
  'result',
  'metric',
  'target',
  'value',
] as const;

export const defaultLeaderboardColumns = [
  {
    name: locale(Keys.RANK),
    title: locale(Keys.RANK),
    field: 'rank',
    type: 'string',
    canSort: true,
  },
  {
    name: locale(Keys.NAME),
    title: locale(Keys.NAME),
    field: 'name',
    type: 'string',
    canSort: false,
  },
  {
    name: locale(Keys.DESCRIPTION),
    title: locale(Keys.DESCRIPTION),
    field: 'description',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: locale(Keys.POINTS),
    title: locale(Keys.POINTS),
    field: 'points',
    type: 'string',
    canSort: true,
    defaultSort: '',
  },
];

export const SUPPORTED_PERFORMANCE_CARDS = ['key_metrics', 'leaderboard'];
